var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    ref: "mainContainer",
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('navigation-tabs'), _vm.isEmptyPartnerList ? [_c('partnership-welcome-screen', [_c('partnership-settings', {
    attrs: {
      "partner": _vm.partner,
      "projects": _vm.personalProjectList
    },
    on: {
      "update-partner": _vm.onUpdatePartner,
      "change-rate": _vm.onChangePartnerRate,
      "load-next": _vm.loadNextPageProjects
    }
  })], 1)] : [_c('div', {
    staticClass: "partnership-settings-container"
  }, [_c('partnership-settings', {
    attrs: {
      "partner": _vm.partner,
      "projects": _vm.personalProjectList
    },
    on: {
      "update-partner": _vm.onUpdatePartner,
      "change-rate": _vm.onChangePartnerRate,
      "load-next": _vm.loadNextPageProjects
    }
  })], 1), _c('project-layout', _vm._l(_vm.partner.childProjects, function (project) {
    return _c('partner-project-card', {
      key: project.projectId,
      attrs: {
        "project": project
      },
      on: {
        "disable-project": _vm.onShownDisableConfirmation,
        "transaction-browsing": _vm.onShownPermissionDialogByStatus
      }
    });
  }), 1), _vm.loadingPush ? _c('img', {
    attrs: {
      "src": require("@/assets/img/loader.svg")
    }
  }) : _vm._e()]], 2), _c('cs-dialog', {
    model: {
      value: _vm.isShownDisableConfirmation,
      callback: function callback($$v) {
        _vm.isShownDisableConfirmation = $$v;
      },
      expression: "isShownDisableConfirmation"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('you.want.turn.off.project.from.partners.program')))]), _c('div', {
    staticClass: "confirmation-control-buttons",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": 190
    },
    on: {
      "click": _vm.onDisablePartner
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.yes')) + " ")]), _c('cs-button', {
    attrs: {
      "type": "transparent"
    },
    on: {
      "click": _vm.onCloseDisableConfirmation
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)])], 1), _c('cs-dialog', {
    model: {
      value: _vm.isShownConfirmChangePermission,
      callback: function callback($$v) {
        _vm.isShownConfirmChangePermission = $$v;
      },
      expression: "isShownConfirmChangePermission"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('have.not.access.to.partner.transactions')))]), _c('div', {
    staticClass: "confirmation-control-buttons",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": 190
    },
    on: {
      "click": _vm.onChangeTransactionsBrowsingPermission
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.yes')) + " ")]), _c('cs-button', {
    attrs: {
      "type": "transparent"
    },
    on: {
      "click": _vm.onCloseChangePermission
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)])], 1), _c('cs-dialog', {
    model: {
      value: _vm.isShownPermissionPending,
      callback: function callback($$v) {
        _vm.isShownPermissionPending = $$v;
      },
      expression: "isShownPermissionPending"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('email.with.request.sent.to.partner')))]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": 190
    },
    on: {
      "click": _vm.onCloseChangePermission
    }
  }, [_vm._v("Ok")])], 1)])], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }